export default __webpack_public_path__ + "locales/nl/Settings.json?hash=d59a8ddbfbc73c17b1e893f9d7c24570";